// Vendor imports
const Immutable = require('immutable')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Client V2 common imports
const { USER_FOLLOWING_CHANGE_PENDING } = require('client-v2/common/models/user/actions')
const ImageUrlSizes = require('client-v2/common/records/image-url-sizes')
const { keyedReviver } = require('client-v2/common/state/revivers')

// Basically just `client-v2/common/models/user/record` with more fields

class ProfileUserRecord extends Immutable.Record({
  bio: null,
  'custom_url': String(),
  'display_name': String(),
  'header_image_urls': null,
  id: null,
  isFollowing: Boolean(),
  isVerifiedCurator: Boolean(),
  mixesBio: null,
  'photo_url': String(),
  type: String(modelTypes.USER),
  username: String()
}) {
  // No methods
}

ProfileUserRecord.reviver = keyedReviver(ProfileUserRecord, {
  'header_image_urls': ImageUrlSizes.reviver
})

if (__DEV__ ) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  ProfileUserRecord.propTypes = {
    bio: PropTypes.string,
    'custom_url': PropTypes.string,
    'display_name': PropTypes.string.isRequired,
    'header_image_urls': PropTypes.shape(ImageUrlSizes.propTypes),
    id: PropTypes.number.isRequired,
    isFollowing: PropTypes.oneOf([true, false, USER_FOLLOWING_CHANGE_PENDING]),
    isVerifiedCurator: PropTypes.bool,
    mixesBio: PropTypes.string,
    'photo_url': PropTypes.string,
    username: PropTypes.string.isRequired
  }
}

module.exports = ProfileUserRecord
